export const SCATTERPLOT_Y = 'scatterplotY';
export const EVENT_LINE_Y = 'eventLineY';
export const ATTRIBUTE = 'attribute';
export const CAT_RANGE_FILTER_TYPE = 'catrange';
export const QTY_RANGE_FILTER_TYPE = 'qtyrange';
export const QUERY_STRING_FILTER_PARSING_ERROR =
	'Query string filter validation failed';
